var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('h3',{staticClass:"ml-1",staticStyle:{"color":"#2662bb"}},[_vm._v(_vm._s(_vm.title))]),_c('FormulaForm',{staticClass:"h-100 overflow-auto p-2 w-100",attrs:{"fields":_vm.getFields(),"item":_vm.item,"key-name":"name","submit-label":"提交","loading":_vm.saveLoading},on:{"submit":_vm.doSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }